// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5dd9cd39","977":"c9c982ea"}[chunkId] + ".chunk.js";
};